import { styleConfig } from '@/config/config';
import { letterSpacing } from '@/config/tokens';

/** Established compact secondary-label treatment, first used by SelectedVariant. */
export const compactMetadataTypography = {
  fontFamily: styleConfig.fonts.body,
  fontSize: 12,
  fontWeight: 800,
  letterSpacing: letterSpacing.proportional,
  textTransform: 'uppercase' as const,
};

export const compactMetadataColor = (isDark = false) =>
  isDark ? styleConfig.color.text.lightOnDark : styleConfig.color.text.grayOnOffwhite;

/**
 * Compact uppercase Bai Jamjuree role for short headings and metric labels.
 * Weight 600 is the strongest Bai face bundled by the application; avoid a
 * synthetic 700 weight, which changes differently between browsers.
 */
export const uppercaseLabelTypography = {
  fontFamily: styleConfig.fonts.header,
  fontWeight: 600,
  letterSpacing: letterSpacing.proportionalWider,
  lineHeight: 1.2,
  textTransform: 'uppercase' as const,
};

/** Primary and secondary actions: uppercase Open Sans with deliberate tracking. */
export const uppercaseActionTypography = {
  fontFamily: styleConfig.fonts.body,
  fontWeight: 600,
  letterSpacing: letterSpacing.wide,
  textTransform: 'uppercase' as const,
};

/** Contextual and navigation actions that intentionally retain sentence case. */
export const sentenceCaseActionTypography = {
  fontFamily: styleConfig.fonts.body,
  fontWeight: 600,
  letterSpacing: 'normal',
  textTransform: 'none' as const,
};

/** Major panel, modal and widget titles use the strongest bundled Bai face. */
export const majorPanelTitleTypography = {
  fontFamily: styleConfig.fonts.header,
  fontWeight: 600,
};

/** Large prices and result values retain hierarchy through size and colour. */
export const emphasizedValueTypography = {
  fontFamily: styleConfig.fonts.header,
  fontWeight: 600,
};
